// extracted by mini-css-extract-plugin
module.exports = {"thumbsUpRadioGroup":"ThumbSelector_thumbsUpRadioGroup__ZzBAk"};